<template>
	<div class="alert-item">
		<el-card class="box-card">
		  <div v-for="(child,index) in realData" :key="index" class="text item">
		    {{ child }}
			<hr style="color: #87CEFA;">
		  </div>
		</el-card>
		
	</div>
</template>

<script>
    export default {
        name: "DataReal",
		mounted() {
		    this.initEmps();
		    
		},
		beforeDestroy() {
			//
			clearTimeout(this.timeId);
		},
		data (){
			return{
				realData: [],
				timeId:''
			}
		},
		methods:{
			initEmps(){
				
				this.getRequest('/data/real/realData').then(resp => {
					/*  */
					/* var data=JSON.stringify(resp); */
					var m=0;
					var data1=new Array();
					var time;
					//debugger
					for( var k in resp ){//遍历packJson 对象的每个key/value对,k为key
						if(k=="time")
						time=resp[k];
						else{
							for(var ky in resp[k])
							data1[m]=ky+':\u3000'+resp[k][ky];
							m++;
						}
					}
					data1[m]=data1[m]='时间:\u3000'+time;
					this.$data.realData=data1;
					 console.log(this.$data.realData); 
					 this.timeId=this.Timer();
				    /* if (resp) {
				        this.nations = resp;
				        window.sessionStorage.setItem("nations", JSON.stringify(resp));
				    } */
				})
			},
			Timer(){
				return setTimeout(()=>{
				          this.initEmps()
				        },2000)
			}
		}
    }
</script>

<style >
	.box-card {
		text-align: left;
		width: 400px;
		
		font-family: 微软雅黑;
		color: #87CEFA;
	}
	.text {
	font-size: 18px;
	}
	.alert-item{
	
	margin-bottom: 10px;
	float: left;
	padding-top: 0px;
	}
	.item {
	padding: 5px 0;
	}
	
	  
</style>